<div class="flex column start center w-100 g-24">
	<h4>{{ 'account.payment_methods' | translateWithKeys }}</h4>
	<div class="flex column start center w-100 g-16">
		@if (loading && !paymentMethods?.length) {
			@for (item of [1, 2, 3, 4]; track $index) {
				<ngx-skeleton-loader [theme]="{ 'height': '88px', 'border-radius': '10px' }"></ngx-skeleton-loader>
			}
		}
		@if (!loading && !paymentMethods?.length) {
			<p>{{ 'account.no_payment_methods_yet' | translateWithKeys }}</p>
		}
		@for (method of paymentMethods; track $index) {
			<app-credit-card-item class="w-100" [paymentMethod]="method" (onPaymentMethodDeleted)="paymentMethodDeletedCb()"></app-credit-card-item>
		}
	</div>
</div>
